import React from "react";
import { Container, Row } from "react-bootstrap";
import "./AboutHero.css";
import Buttonfilled from "../Buttonfilled/Buttonfilled";
import { renderTextWithNormalDash } from "../../utils/textFormatters";

const AboutHero = ({ page = "about", img, title, subtitle, pageText = "" }) => {
    const titlesplitted = title ? title.split(" ") : [];
    const titleTextcut = titlesplitted.slice(0, -1).join(" ");
    const titleGradient = titlesplitted.slice(-1).join(" ");
    return (
        <section className={`about-hero-section d-flex align-items-center ${page === "insight" ? "bg-black" : ""} `} style={{ backgroundImage: `url(${img})` }}>
            {page !== "about" && (
                <div className="about-hero-gradient" />
            )}
            <div className="about-gradient-overlay" />
            <Container className={`${page === "insight" ? "d-flex justify-content-center text-center" : ""}`}>
                <div className="about-hero-content text-white">
                    <Row>
                        <h1 className="about-hero-title">
                            {titleTextcut} <span className="text-gold">{titleGradient}</span>
                        </h1>
                    </Row>
                    <Row >
                        <p className="about-hero-subtitle safe-text">
                            {renderTextWithNormalDash(subtitle)}
                        </p>
                    </Row>
                    {page !== "about" && page !== "contact" && page !== "insights" && (
                        ( pageText === "contact-lenses" || pageText === "safety-glasses" || pageText === "sports-goggles" ? (<Buttonfilled text="Send us a message" />) : (<Buttonfilled text = "Book an Eye Exam"/>) )
                    )}
                </div>
            </Container>
        </section >
    );
};

export default AboutHero;
